import { jsx as _jsx } from "react/jsx-runtime";
export function CurlyBracesIcon(param) {
    let { className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 19.4 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M5.7 17C4.04 17 2.7 15.66 2.7 14V11.56C2.7 10.95 2.42 10.38 1.95 10L1.19 9.39C0.94 9.19 0.94 8.81 1.19 8.61L1.95 8C2.42 7.62 2.7 7.05 2.7 6.44V4C2.7 2.34 4.04 1 5.7 1M13.7 17C15.36 17 16.7 15.66 16.7 14V11.56C16.7 10.95 16.98 10.38 17.45 10L18.21 9.39C18.46 9.19 18.46 8.81 18.21 8.61L17.45 8C16.98 7.62 16.7 7.05 16.7 6.44V4C16.7 2.34 15.36 1 13.7 1",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    });
}
